export const fetchSeoData = async ({ seoModel, page, pageSize, order, language, bffUri, }) => {
    if (!seoModel)
        return Promise.resolve({});
    const response = await fetch([bffUri, 'seo/data'].join(''), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify({
            properties: {},
            locale: language,
            criteria: seoModel,
            paging: {
                order,
                page,
                size: pageSize,
            },
        }),
        signal: AbortSignal.timeout(1500),
    });
    if (response.ok) {
        const deserialized = (await response.json());
        return {
            linkboxes: deserialized?.linkboxes?.seoLinkBoxes,
            breadcrumb: deserialized?.breadcrumb?.data?.links,
            content: deserialized?.content,
        };
    }
    return {};
};
